import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

const HtmlPageStore = {
  state: {
    namespaced: true,
    htmlPage: {
      id: '',
      title: '',
      published: false,
      isIndex: true,
      slug: '',
      applyVersion: '',
      htmlPageVersions: []
    }
  },
  mutations: {
    SET_HTML_PAGE (state, htmlPage) {
      state.htmlPage = htmlPage
    },
    SET_HTML_PAGE_VERSIONS (state, htmlPageVersions) {
      state.htmlPage.HtmlPageVersions = htmlPageVersions
    },
    UPDATE_HTML_PAGE_VERSION_NAME (state, { versionId, name }) {
      const htmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === versionId
      )
      htmlPageVersion.name = name
    },
    UPDATE_HTML_PAGE_VERSION_HEAD_CONTENT (state, { versionId, headContent }) {
      const htmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === versionId
      )
      htmlPageVersion.headContent = headContent
    },
    UPDATE_HTML_PAGE_VERSION_BODY_CONTENT (state, { versionId, bodyContent }) {
      const htmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === versionId
      )
      htmlPageVersion.bodyContent = bodyContent
    },
    UPDATE_HTML_PAGE_VERSION_CSS_CONTENT (state, { versionId, cssContent }) {
      const htmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === versionId
      )
      htmlPageVersion.cssContent = cssContent
    },
    UPDATE_HTML_PAGE_VERSION_DELIVERY_RATE (state, { versionId }) {
      const publishingHtmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.deliveryRate === 1
      )
      const privateHtmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === versionId
      )
      if (publishingHtmlPageVersion) {
        publishingHtmlPageVersion.deliveryRate = 0
      }
      privateHtmlPageVersion.deliveryRate = 1
    },
    UPDATE_HTML_PAGE_VERSION_NOT_UPDATED (state, { htmlPageVersionId }) {
      const htmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === htmlPageVersionId
      )
      htmlPageVersion.notUpdated = true
    },
    CHANGE_HTML_PAGE_VERSION_NOT_UPDATED (state, { htmlPageVersionId }) {
      const htmlPageVersion = state.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === htmlPageVersionId
      )
      htmlPageVersion.notUpdated = false
    }
  },
  getters: {
    getHtmlPageVersion: (state) => (id) => {
      if (state.htmlPage.htmlPageVersions) {
        return state.htmlPage.htmlPageVersions.find(
          (htmlPageVersion) => htmlPageVersion.id === id
        )
      } else {
        return {}
      }
    }
  },
  actions: {
    fetchHtmlPage (context, query) {
      return new Promise((resolve, reject) =>
        axios.get(`/api/html_pages/${query.htmlPageId}`).then(
          ({ data }) => {
            context.commit('SET_HTML_PAGE', deserialize(data).data)
            resolve()
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            context.dispatch('SystemMessageStore/createMessage', payload, {
              root: true
            })
            reject(error)
          }
        )
      )
    }
  }
}

export default HtmlPageStore
